<template>
  <v-row class="financial-component-container" no-gutters>
    <v-col>
      <v-row no-gutters v-if="quotation != null" class="print-container pb-1">
        <v-col>
          <v-row>
            <img src="@/assets/header-v2.png" class="header-image pt-0" />
            <h3>{{ getQuotationTitle() }}</h3>
          </v-row>

          <v-row class="layout-wrapper" no-gutters>
            <v-col cols="6" class="flex-wrapper mb-1 d-flex justify-start">
              <table class="quotation-overview-table">
                <tr>
                  <td style="width: 30%">Cargo ready date</td>
                  <td style="width: 2%">:</td>
                  <td>{{ quotation.cargo_ready_date }}</td>
                </tr>
                <tr>
                  <td>Port of loading</td>
                  <td>:</td>
                  <td>
                    {{
                      quotation.origin_port.name +
                      ", " +
                      quotation.origin_port.code_country
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Port of discharge</td>
                  <td>:</td>
                  <td>
                    {{
                      quotation.destination_port.name +
                      ", " +
                      quotation.destination_port.code_country
                    }}
                  </td>
                </tr>

                <tr>
                  <td>Transaction</td>
                  <td>:</td>
                  <td>{{ quotation.transaction_type }}</td>
                </tr>
                <tr>
                  <td>Incoterm</td>
                  <td>:</td>
                  <td>{{ quotation.incoterm.incoterm }}</td>
                </tr>
                <tr>
                  <td>Cargo type</td>
                  <td>:</td>
                  <td>{{ quotation.cargo_type.code }}</td>
                </tr>
                <tr>
                  <td>Commodity</td>
                  <td style="width: 2%">:</td>
                  <td>{{ quotation.commodity }}</td>
                </tr>
              </table>
            </v-col>

            <v-col class="flex-wrapper mb-1 d-flex justify-end">
              <table class="quotation-overview-table">
                <tr>
                  <td style="width: 30%">Container load:</td>
                  <td style="width: 2%">:</td>
                  <td>{{ quotation.container_load }}</td>
                </tr>
                <tbody v-if="quotation.container_load == 'FCL'">
                  <tr>
                    <td>Container size:</td>
                    <td>:</td>
                    <td>{{ quotation.container_sizes.join(" & ") }} footer</td>
                  </tr>
                  <tr>
                    <td># of containers:</td>
                    <td>:</td>
                    <td>{{ quotation.container_total }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td>Gross weight/unit:</td>
                    <td>:</td>
                    <td>{{ quotation.total_weight }} kg</td>
                  </tr>
                  <tr>
                    <td>Cubic meter/unit</td>
                    <td>:</td>
                    <td>
                      {{ quotation.total_cubic_meters }}
                      <span style="font-size: 15px">&#13221;</span>
                    </td>
                  </tr>
                  <tr v-if="quotation.container_load == 'AIR'">
                    <td>Chargeable weight:</td>
                    <td>:</td>
                    <td>{{ quotation.quantity }} kg</td>
                  </tr>
                </tbody>
                <tr>
                  <td>Customer ID</td>
                  <td>:</td>
                  <td>{{ quotation.company_id }}</td>
                </tr>
                <tr>
                  <td>Customer name</td>
                  <td>:</td>
                  <td>{{ quotation.company.name }}</td>
                </tr>
                <tr>
                  <td>Date</td>
                  <td>:</td>
                  <td>{{ updated_date }}</td>
                </tr>
                <tr>
                  <td>Valid until</td>
                  <td>:</td>
                  <td>{{ CONSTANT.addDaysToDate(updated_date, 14) }}</td>
                </tr>
              </table>
            </v-col>
          </v-row>

          <!-- Financial Table -->
          <v-row
            no-gutters
            v-if="
              quotation.has_complete_price ||
              quotation.override_has_complete_price
            "
          >
            <v-col>
              <v-row class="financial-component-container my-0">
                <financial-component-table
                  v-model="quotation"
                  :show-cost="false"
                ></financial-component-table>
              </v-row>

              <v-row justify="start">
                <span class="title black--text pl-1">Remarks</span>
              </v-row>

              <v-row class="remarks-table-container py-0">
                <table class="table-remarks">
                  <tr>
                    <th colspan="2"></th>
                  </tr>

                  <tr>
                    <td class="pl-3">
                      - All currency conversion are based on the weekly exchange
                      rates provided by Malayan Banking Berhad.
                    </td>
                  </tr>

                  <tr>
                    <td class="pl-3">
                      - Any customs duties/local taxes (SST/GST) payable will be
                      advised to you. Upon confirmation, you shall prepare the
                      amount due payable to the customs or alternatively to
                      ACCELE FREIGHT SDN BHD.
                      <b>PAYMENT HAS TO BE MADE IN ADVANCE BEFORE DELIVERY.</b>
                    </td>
                  </tr>

                  <tr>
                    <td class="pl-3">
                      - Quoted price does not include tax and duties of goods,
                      port storage, demurrage, insurance, and/or any additional
                      charges incurred at customs.
                    </td>
                  </tr>

                  <tr>
                    <td class="pl-3">
                      - Quoted price does not include sales and service tax. All
                      shipment related taxes will be applied on invoice where
                      applicable
                    </td>
                  </tr>

                  <tr>
                    <td class="pl-3">
                      - Additional costs outside of quoted shipping terms will
                      be charged to the customer
                    </td>
                  </tr>

                  <tr>
                    <td class="pl-3">
                      - Final cost may change due to difference in final weight
                      and/or dimensions, transport requirements, customs, and
                      variation in market rates.
                    </td>
                  </tr>

                  <tr>
                    <td class="pl-3">
                      - All cargo shipped mustbe seaworthy/airworthy. Accele
                      Freight Sdn Bhd will not held responsible for any damaged,
                      crushed, or lost cargoes during transit.
                    </td>
                  </tr>

                  <tr>
                    <td></td>
                  </tr>
                </table>
              </v-row>

              <br />

              <v-row class="px-2"
                >We hope the quotation above meets your requirements and look
                forward to the opportunity to serve you.</v-row
              >

              <v-row class="pt-4" style="font-size: 20px" justify="center">
                <b
                  >This is a computer generated document. No signature is
                  required</b
                >
              </v-row>
            </v-col>
          </v-row>

          <v-row v-else class="px-3 pb-5" no-gutters>
            <v-col>
              <b
                >We sincerely apologize as we currently do not have the complete
                rates for your requested shipment.</b
              >
              <br />We will be reaching out to you with an updated quote for
              your requirement. At the meantime, should you have any inquiries,
              please feel free to reach out to us at
              <a href="mailto: info@accelefreight.com"
                >info@accelefreight.com</a
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-alert tile style="z-index: 1" type="info" class="my-10"
          >This quotation does not have any Financial Component yet.</v-alert
        >
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios"
import constant from "../../const"

export default {
  data() {
    return {
      CONSTANT: constant,
      quotation: null,
      id: null,
      // token: null,
      // company_id: null
    }
  },

  created() {
    this.$root.fullScreenView = false
    this.id = this.$route.query.id
    // get the token sent from the cloud function
    // this.token = this.$route.query.token;

    // make a get axios api call to get the quotation detail
    axios
      .get(`${constant.API_HOST}/api/quotations/download/${this.id}`)
      .then((resp) => {
        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          this.quotation = resp.data.data
        } else {
          console.log(resp.data)
        }
      })
      .catch((err) => {
        console.log(err)
      })

    // axios
    //   .get(`${constant.API_HOST}/api/quotations/puppeteer/${this.id}`, {
    //     headers: {
    //       Authorization: `${this.token}`
    //     }
    //   })
    //   .then(resp => {
    //     if (resp.data.status == constant.RESPONSE_STATUS_OK) {
    //       this.quotation = resp.data.data;
    //     } else {
    //       console.log(resp.data);
    //     }
    //   })
    //   .catch(err => {
    //     console.log(err);
    //   });
  },

  mounted() {},

  methods: {
    getQuotationTitle() {
      var quotationIDLabel =
        this.quotation.quotation_id != null
          ? this.quotation.quotation_id
          : "DRAFT"

      return (
        "[" +
        quotationIDLabel +
        "] " +
        this.quotation.transaction_type +
        " " +
        this.quotation.container_load +
        " " +
        this.quotation.incoterm.incoterm +
        " " +
        this.quotation.cargo_type.code +
        " " +
        this.quotation.origin_port.name +
        " to " +
        this.quotation.destination_port.name
      )
    },
  },

  watch: {},

  computed: {
    updated_date: {
      get() {
        if (this.quotation.updated == null) {
          return constant.getDate(0)
        } else {
          return this.quotation.updated.substring(0, 10)
        }
      },
    },
  },
}
</script>

<style>
.financial-component-container {
  margin: 0px 30px 0px 30px;
}

.print-container {
  padding: 20px 30px 20px 30px;
  background-color: #fff;
}

.print-container h3 {
  padding-left: 5px;
}

.layout-wrapper {
  padding: 0;
}

.flex-wrapper {
  margin: 20px 10px 20px 20px;
  /* width: 50%; */
}

.financial-component-container {
  margin: 20px 5px 20px 5px;
}

.quotation-overview-table tr td {
  text-align: left;
  font-size: 13px;
  padding: 2px;
}

.quotation-overview-table tr td:first-child {
  min-width: 120px;
  width: 10%;
}

.remarks-table-container {
  padding: 20px 5px;
  /* margin-top:160px; */
}

.table-remarks tr th {
  font-size: 16px;
  padding-left: 20px;
  /* border: 1px solid black; */
}

.table-remarks tr td {
  font-size: 10px;
  /* border-left: 1px solid black;
  border-right: 1px solid black; */
  text-align: left;
  padding: 2px 10px 2px 25px;
}

/* .table-remarks tr:last-child td {
  border-bottom: 1px solid black;
} */

.financial-component-container .print-btn button.v-btn.theme--light {
  border: 1px solid #0546f3;
  color: #0546f3 !important;
}
.financial-component-container .print-btn button.v-btn.theme--light:hover {
  background-color: #0546f3 !important;
  color: #fff !important;
}
.v-dialog__content.v-dialog__content--active {
  background-color: rgba(0, 0, 0, 0.25);
}
</style>
